/* Purpose: Generic loading page
 * Props: 
 * Author: R. Markowitz (April 2025)
 * Dev Notes: 
*/
import React from "react";
import { Container, Spinner} from "react-bootstrap";
import SloganHeader from "./SloganHeader";

const Loading = () => {
    return(
        <div className="align-items-center my-auto loading-page">
            <SloganHeader />
            <Container className="text-center m-7 ms-auto my-auto">
                
                <h1 className="m-4 text-color-info">Loading</h1>
                <Spinner 
                    as="span"
                    animation="grow"
                    role="status"
                    aria-hidden="true" 
                    className="m-1"
                />
                <Spinner 
                    as="span"
                    animation="grow"
                    role="status"
                    aria-hidden="true" 
                    className="m-1"
                />
                <Spinner 
                    as="span"
                    animation="grow"
                    role="status"
                    aria-hidden="true" 
                    className="m-1"
                />
                    
            </Container>
        </div>
    );
}

export default Loading;